/**
 * If given a value of type Error, return it — otherwise wrap the value in an Error.
 *
 * Useful in catch blocks where the caught value is `unknown`.
 * Adapted from camera-kit-web-sdk shared-resources.
 */
export const ensureError = (error: unknown): Error => {
    if (error instanceof Error) return error;

    try {
        return new Error(`Non-Error type exception thrown. Serialized error value: ${JSON.stringify(error)}`);
    } catch {
        return new Error("Non-Error type exception thrown. Original error value could not be serialized.");
    }
};
